import React from 'react';
import styles from './customDots.module.css';

const CustomDot = ({ onClick, active }) => {
    return (
        <li className={styles.li}>
            <div
                onClick={onClick}
                className={`${styles.dot} ${active ? styles.active : ''}`}
                role="button"
                tabIndex={0}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') onClick(); }}
                aria-pressed={active}
            />
        </li>
    );
};

export default CustomDot;